import { IState } from "@redux/store.types";
import { getValueState } from "@redux/utils";

import { $AddToCartModuleName } from "./addToCart.types";

const getAddToCartState = (state: IState) =>
    getValueState(state, $AddToCartModuleName);

export { getAddToCartState };
